import servise from '@/router/axios'

export const getCreative = (params) => {
  return servise({
    url: '/webIdea/get',
    method: 'get',
    params
  })
}

export const addCreative = (data) => {
  return servise({
    url: '/webIdea/add',
    method: 'post',
    data
  })
}

export const updataCrerative = (data) => {
  return servise({
    url: '/webIdea/revise/creative',
    method: 'PUT',
    data
  })
}

export const upstataCreative = (data) => {
  return servise({
    url: '/webIdea/revise/state',
    method: 'PUT',
    data
  })
}

export const upCreativeAudit = (data) => {
  return servise({
    url: '/creative/revise/creative/review',
    method: 'PUT',
    data
  })
}
export const getId = (params) => {
    return servise({
      url: '/slot/get/name/id',
      method: 'get',
      params
    })
  } 

  export const getTemplate = (params) => {
    return servise({
      url: '/slotTemplate/slot/template/list',
      method: 'get',
      params
    })
  }

  export const getAuditList = (params) => {
    return servise({
      url: '/slotTemplate/slot/verfy/status/list',
      method: 'get',
      params
    })
  }